import axios from "axios";

class EndpointError extends Error {
  constructor(obj, msg) {
    super();
    this.name = "EndpointError";
    this.message = obj;
    console.error("EndpointError detail", obj, msg);
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(obj).stack;
    }
  }
}

class Fetcher {
  constructor(apis, endpoints) {
    this.apis = apis;
    this.endpoints = endpoints;
  }

  apis = {};
  defaultApi = undefined;
  endpoints = {};
  method = "GET";
  body = null;

  customOptions = {};

  get proxy() {
    const that = this;

    return new Proxy(that.endpoints, {
      get(target, prop) {
        that.defaultApi = apis[prop] || apis["ip"];
        if (!target[prop]) throw new EndpointError("There isn't such endpoint", target[prop]);
        return new Proxy(target[prop], {
          get(subTarget, subProp) {
            if (!subTarget[subProp])
              throw new EndpointError("There isn't such endpoint", target[prop]);
            return (...params) => {
              const all = [...params];
              return that.call(that.endpoints[prop][subProp](...all));
            };
          },
        });
      },
    });
  }

  get from() {
    return this.proxy;
  }
  get to() {
    return this.proxy;
  }

  call = async (endpoint) => {
    try {
      if (!this.defaultApi) return false;

      const url = `${this.defaultApi}/${endpoint}`.replace(/([^:]\/)\/+/g, "$1");
      const body = this.body ? { data: this.body } : {};
      const options = {
        method: this.method,
        ...body,

        ...this.customOptions,
      };

      return await this.requestCall(url, options);
    } catch (e) {
      console.log("e", e);
      return e;
    }
  };

  requestCall = async (url, options) => {
    try {
      const res = await axios({
        url: url,

        ...options,
      });
      return res;
    } catch (error) {
      console.log("error", error);
      console.log("error-response", error.response);
      return error.response;
    }
  };

  setOptions = (customOptions) => {
    this.customOptions = customOptions;
    return this;
  };

  get get() {
    this.method = "GET";
    this.body = null;
    return this;
  }

  post = (body) => {
    this.method = "POST";
    this.body = body || {};
    return this;
  };

  put = (body) => {
    this.method = "PUT";
    this.body = body || {};
    return this;
  };

  get delete() {
    this.method = "DELETE";
    return this;
  }
}

const API_BASE_URL = process.env.REACT_APP_API;

const apis = {
  ip: `${API_BASE_URL}/`,
};

const endpoints = {
  auth: {
    login: () => `/auth/login`,
    logout: () => `/auth/logout`,
  },
  products: {
    get_family_types: () => `/products/get_family_types`,
    get_family_log: () => `/products/get_family_log`,
    get_family_log_part: () => "/products/get_family_log_part",
    get_colors: () => `/products/get_colors`,
    calc_frame_openings: () => `/products/calc_frame_openings`,
  },
  orders: {
    get_cust_orders: () => `/orders/get_cust_orders`,
    get_report: () => `/orders/get_report`,
    set_orders_report: () => `/orders/set_orders_report`,
    get_project_order: () => `/orders/get_project_order`,
    get_project_order_products: () => `/orders/get_project_order_products`,
  },
  projects: {
    get_cust_projects: () => `/projects/get_cust_projects`,
    get_item_details: () => `/projects/get_item_details`,
    get_supply_order_items: () => `/projects/get_supply_order_items`,
    get_supply_orders: () => `/projects/get_supply_orders`,
    get_project_frame: () => `/projects/get_project_frame`,
    get_frame_details: () => `/projects/get_frame_details`,
    get_supply_order: () => `/projects/get_supply_order`,
    get_cust_projects_orders: () => `/projects/get_cust_projects_orders`,
  },
  common: {
    general_load: () => `/common/general_load`,
    get_general_load: () => `/common/get_general_load`,
    update_general_load: () => `/common/update_general_load`,
    update_general_load_line: () => `/common/update_general_load_line`,
    delete_general_load_line: () => `/common/delete_general_load_line`,
    add_general_load_line: () => `/common/add_general_load_line`,
    get_positions: () => `/common/get_positions`,
    get_cities: () => `/common/get_cities`,
    get_countries: () => `/common/get_countries`,
    get_zones: () => `/common/get_zones`,
    get_customer_types: () => `/common/get_customer_types`,
  },
};

let cachedToken = null;

export const setFetcherToken = (token) => {
  cachedToken = token || null;
};

export const clearFetcherToken = () => {
  cachedToken = null;
};

const fetcher = () => {
  const token = cachedToken ?? (() => {
    const localStorageUser = JSON.parse(localStorage.getItem("acp-user"));
    return localStorageUser?.userDetails?.token || process.env.REACT_APP_DEFAULT_TOKEN;
  })();

  return new Fetcher(apis, endpoints).setOptions({
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
    },
  });
};

export default fetcher;
